<script>
    import { fade, fly } from "svelte/transition";
    export let modalFAQ;
</script>

<div
    on:click|self
    class="absolute top-0 right-0 flex items-center justify-center w-full h-full bg-black modal bg-opacity-60"
>
    <div
        in:fly={{ y: 150, duration: 400 }}
        class="relative w-1/2 p-6 text-xl bg-white rounded-md content"
    >
        <h2>{modalFAQ.question}</h2>
        <button
            class="absolute top-0 right-0 mt-2 mr-2 text-black border-0 shadow-none hover:text-primary hover:shadow-none"
            on:click
        >
            <svg
                class="w-8 h-8 fill-current "
                viewBox="0 0 123 123"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M82.276 41.0573C80.1093 38.901 76.6093 38.901 74.4427 41.0573L61.6667 53.8333L48.9427 41.0573C46.7656 38.875 43.2344 38.875 41.0572 41.0573C38.8749 43.2344 38.8749 46.7656 41.0572 48.9428L53.8332 61.6668L41.0572 74.3908C39.8801 75.396 39.1769 76.8492 39.1197 78.396C39.0572 79.9429 39.6458 81.4429 40.7395 82.5366C41.8332 83.6304 43.3384 84.2189 44.8853 84.1617C46.4323 84.0992 47.8801 83.3961 48.8905 82.2242L61.6665 69.5002L74.3905 82.2242C76.5936 84.1097 79.8801 83.9846 81.9321 81.9326C83.9843 79.8804 84.1092 76.594 82.2238 74.391L69.4998 61.667L82.2238 48.943C83.2811 47.9065 83.8853 46.4951 83.8957 45.0107C83.9061 43.5315 83.3227 42.1044 82.2759 41.0576L82.276 41.0573Z"
                />
                <path
                    d="M61.6667 0.557312C45.4587 0.557312 29.9173 6.99478 18.4533 18.4533C6.99494 29.9169 0.557335 45.4586 0.557335 61.6666C0.557335 77.8746 6.9948 93.416 18.4533 104.88C29.9169 116.338 45.4587 122.776 61.6667 122.776C77.8747 122.776 93.416 116.339 104.88 104.88C116.338 93.4164 122.776 77.8746 122.776 61.6666C122.776 45.4586 116.339 29.9173 104.88 18.4533C93.4164 6.99491 77.8747 0.557312 61.6667 0.557312V0.557312ZM61.6667 111.667C48.4063 111.667 35.688 106.401 26.312 97.0213C16.9317 87.6464 11.6667 74.928 11.6667 61.6666C11.6667 48.4053 16.9323 35.688 26.312 26.312C35.6869 16.9317 48.4053 11.6666 61.6667 11.6666C74.928 11.6666 87.6453 16.9322 97.0213 26.312C106.402 35.6869 111.667 48.4053 111.667 61.6666C111.667 74.928 106.401 87.6453 97.0213 97.0213C87.6464 106.402 74.928 111.667 61.6667 111.667V111.667Z"
                />
            </svg>

            <span class="sr-only">Close</span>
        </button>
        <p class="pt-4">{modalFAQ.answer}</p>
    </div>
</div>
